import React from 'react';

type Props = {
  keyLabel: string;
  children?: React.ReactNode;
};

export const KeyValue = (props: Props) => (
  <div className='key-value key-value--vault key-value--inline'>
    {props.keyLabel}
    <span className='key-value__value'>{props.children}</span>
  </div>
);
